import r from "lodash/isDate";
import { addDays as l } from "../date-info.js";
import { datesAreEqual as n, pageForDate as u } from "../helpers.js";
class h {
  constructor({ format: e, parse: t }) {
    Object.assign(this, { format: e, parse: t });
  }
  hasValue(e) {
    return !!(r(e) || new Date(e).getTime() > 0);
  }
  normalize(e) {
    return e && new Date(e);
  }
  valuesAreEqual(e, t) {
    return n(e, t);
  }
  formatValue(e) {
    return this.hasValue(e) ? this.format(e) : "";
  }
  parseValue(e) {
    const t = this.parse(e);
    return r(t) ? t : null;
  }
  filterDisabled({ value: e, isRequired: t, disabled: a, fallbackValue: s }) {
    return !this.hasValue(e) && t ? s : this.hasValue(e) && a && a.intersectsDate(e) ? null : e;
  }
  getPageRange(e) {
    if (!this.hasValue(e))
      return null;
    const t = u(e);
    return { from: t, to: t };
  }
  parseShortcutValue(e) {
    return e = r(e) ? e : l(/* @__PURE__ */ new Date(), e), e.setHours(0, 0, 0, 0), this.normalize(e);
  }
  handleShortcutSelect(e, t) {
    t.dateIsValid(e.value) && (t.model = e.value);
  }
  handleDayClick(e, t) {
    t.dateIsValid(e.date) && (this.valuesAreEqual(e.date, t.model) ? t.isRequired ? t.togglePopover() : (t.model = null, t.$emit("select-date", { value: null })) : (t.model = e.date, t.$emit("select-date", { value: e.date })));
  }
  handleDayMouseEnter() {
  }
}
export {
  h as default
};
//# sourceMappingURL=single.js.map
